require('../modules/esnext.math.signbit');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/proposals/math-signbit.js
// module id = 860
// module chunks = 2